<template>
  <div class="notice-center">
    <div class="notice-header">
      <div class="header-wrap">
        <div class="header-left">
          通知中心
        </div>
      </div>
    </div>
    <div class="notice-con">
      <div class="notice-con-header">
        <div class="header-left">
          <span class="read-btn" @click="_readAllNotice">全部已读</span>
        </div>
        <div class="header-right">
          <el-select v-model="filterType" placeholder="请选择" @change="handleTypeChange">
            <el-option
              v-for="item in filterTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <el-table
      :data="tableData"
      v-loading="tableLoad"
      tooltip-effect="light"
      style="width: 100%">
        <el-table-column
          class="mirror-name"
          label="标题内容"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-html="scope.row.content" :class="{'viewed': scope.row.view}" class="content-column" />
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          width="200"
          label="时间">
          <template slot-scope="scope">
            <span :class="{'viewed': scope.row.view}">{{ new Date(scope.row.createDate).Format("yyyy-MM-dd hh:mm:ss") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          width="150"
          label="消息类型">
          <template slot-scope="scope">
            <span :class="{'viewed': scope.row.view}">
              {{ scope.row.type === 0 ? '公告' : scope.row.type === 1 ? '提醒' : scope.row.type === 2 ? '产品服务' : '活动消息' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          width="80"
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" class="view" :class="{'viewed': scope.row.view}" @click="handleView(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="basePagenate">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :current-page="pageNumber"
          :total="total"
          layout="prev, pager, next">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getNoticeList, readNotice, readAllNotice } from '@/api/notice'
import { mapGetters, mapMutations } from 'vuex'
import { replaceUrl } from '@/common/js/utils'

export default {
  data () {
    return {
      // 总页数
      total: 0,
      tableData: [
        {
          name: '',
          docker: '',
          timer: '',
          language: '',
          algorithm: '',
          operation: ''
        }
      ],
      // 每页条数
      pageSize: 10,
      selectedMirro: {},
      // 当前页
      pageNumber: 1,
      mirrorDeleteBtn: false,
      tableLoad: false,
      filterType: -1,
      filterTypeOptions: [
        {
          label: '全部类型',
          value: -1
        },
        {
          label: '公告',
          value: 0
        },
        {
          label: '提醒',
          value: 1
        },
        {
          label: '产品服务',
          value: 2
        },
        {
          label: '活动消息',
          value: 3
        }
      ]
    }
  },

  // components: {},

  // computed: {},

  mounted () {
    this._getNoticeList()
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'noticeCount'
    ])
  },
  methods: {
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNumber = val
      this._getNoticeList()
    },
    handleCurrentChange (val) {
      this.pageNumber = val
      this._getNoticeList()
    },
    handleTypeChange (val) {
      this.pageNumber = 1
      this.filterType = val
      this._getNoticeList()
    },
    // 查看通知
    handleView (row) {
      if (row.view === 0) {
        const query = `?token=${this.userInfo.token}`
        const data = {
          noticeIdList: []
        }
        data.noticeIdList.push(row.id)
        readNotice(query, data).then(res => {
          if (res.code === 0) {
            if (row.type === 0) {
              this.setNoticeContent(row.content)
              this.setNoticeCount(Number(this.noticeCount) - 1)
              this.$router.push({ path: '/notice/detail' })
            } else {
              let url = replaceUrl(row.url)
              window.open(url)
            }
          } else {
            this.$message({ message: res.msg, showClose: true, type: 'error' })
          }
        })
      } else {
        if (row.type === 0) {
          this.setNoticeContent(row.content)
          this.$router.push({ path: '/notice/detail' })
        } else {
          window.location.href = replaceUrl(row.url)
        }
      }
    },
    // 获取通知列表
    _getNoticeList () {
      const query = `?type=${this.filterType}&platform=1&pageNumber=${this.pageNumber}&pageSize=${this.pageSize}&token=${this.userInfo.token}`
      this.tableLoad = true
      getNoticeList(query).then(res => {
        this.tableLoad = false
        if (res.code === 0) {
          this.tableData = res.result
          this.total = res.count
        } else {
          this.$message({ message: res.msg, showClose: true, type: 'error' })
        }
      })
    },
    // 读取所有通知
    _readAllNotice (readId) {
      const query = `?token=${this.userInfo.token}&platform=1`
      readAllNotice(query).then(res => {
        if (res.code === 0) {
          this.$message({ message: '操作成功', showClose: true, type: 'success' })
          this.pageNumber = 1
          this.filterType = -1
          this._getNoticeList()
          this.setNoticeCount(0)
        } else {
          this.$message({ message: res.msg, showClose: true, type: 'error' })
        }
      })
    },
    ...mapMutations({
      setNoticeContent: 'SET_NOTICE_CONTENT',
      setNoticeCount: 'SET_NOTICE_COUNT'
    })
  }
}

</script>
<style lang="stylus">
.notice-center
  .notice-header
    width 100%
    background #F4F7F8
    .header-wrap
      max-width 1162px
      margin  0 auto
      padding 30px 0
      display flex
      justify-content space-between
      align-items center
      .header-left
        font-size 28px
        line-height 40px
        color #2D323B
        font-weight bold
      .header-right
        .el-button
          padding 8px 31px
          font-size 14px
          line-height 20px
  .notice-con
    max-width 1162px
    margin 23px auto 0
    .notice-con-header
      display flex
      justify-content space-between
      padding-bottom 20px
      align-items center
      font-size 14px
      .read-btn
        padding 10px
        background #f4f4f4e6
        border-radius 6px
        cursor pointer
        &:hover
          background #ccc
    .viewed
      color #9E9E9E
      h1
        color #9e9e9e
    .content-column
      height 23px
      line-height 23px
      overflow hidden
      text-overflow ellipsis
      display -webkit-box
      /*! autoprefixer: off */
      -webkit-box-orient vertical
      /* autoprefixer: on */
      -webkit-line-clamp 1
      word-break break-all
      word-wrap break-word
    .el-table th
      background #F1F8FF
    .el-table th.is-leaf
      border-bottom none
    .el-table td.mirror-name
      color #2196F3
      cursor pointer
    .view
      font-size 14px
      color #333333
.mirror-name-text
  cursor pointer
  font-size 14px
</style>
